export { default as DualText } from './DualText';
